import React from 'react';
import './apiPackage.css'; // Create this CSS file for custom styles

const apiPackages = [
  {
    name: "Text AI",
    credits: "1 Credit per 10 words",
    price: "USD 0.002 per word",
    background: "#05C0A2",
  },
];

const APIPackage = () => {
  const handlePackageClick = (packageName) => {
    alert(`You selected the ${packageName} package.`);
  };

  return (
    // clas 
    <div className="row g-4 py-md-5 py-3 d-flex justify-content-center">
      {apiPackages.map((item, index) => (
        <div className="col-md-6 col-lg-4 col-12" key={index}>
          <div style={{ borderRadius: "10px" }} className="bg-white">
            <div
              className="package-price text-center"
              style={{ background: `${item.background}` }}
            >
              <h2>{item.name}</h2>
              
            </div>
            <div>
              
              <div className="each-row py-4">
                
                <p className="row-value mb-0">
                  {item.credits}
                </p>
              </div>
              <div className="each-row py-4 border-0">
                <p className="row-header mb-2">Low as {item.price}</p>
                
              </div>
              <div className="pay-button-container">
                <button
                  className="pay-button"
                >
                  {item.price}
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default APIPackage;
